import type { ReactNode } from 'react';
import { useAttachment } from '../db/attachments';
import { IMAGE_ICON, isImageIcon } from '../lib/pageIcon';

function ImageIcon({ name, className }: { name: string; className?: string }) {
  const file = useAttachment(name);
  return file ? (
    <img
      src={file.url}
      alt=""
      draggable={false}
      className={className}
      style={{ width: '1em', height: '1em', objectFit: 'contain', borderRadius: '0.2em' }}
    />
  ) : (
    <span style={{ display: 'inline-block', width: '1em', height: '1em' }} />
  );
}

/**
 * A page's icon: an emoji, or an uploaded image (sized like the text around it),
 * or `fallback` when the page has none.
 */
export function PageIcon({
  icon,
  fallback = null,
  className,
}: {
  icon: string | null | undefined;
  fallback?: ReactNode;
  className?: string;
}) {
  if (!icon) return <>{fallback}</>;
  if (isImageIcon(icon))
    return <ImageIcon name={icon.slice(IMAGE_ICON.length)} className={className} />;
  return <>{icon}</>;
}
